import { MapItinerary } from "../models/map.itinerary";
import { MapLatLng } from "../models/map.latlng";
import { GMapComponent } from "./gmap.component";

export class GMapItinerary extends MapItinerary {
    private directionsService: google.maps.DirectionsService;
    private directionsRenderer: google.maps.DirectionsRenderer;
    private autocompleteFrom: any;
    private autocompleteFromListener: any
    private autocompleteTo: any;
    private autocompleteToListener: any
    private origen?: any;
    private destino?: any;

    constructor(map: any, ngZone: any, fromId: string, toId: string, fromPos: MapLatLng,
        toPos: MapLatLng, resultId: string, gMap: GMapComponent) {
        super(map, fromId, toId, resultId);
        // Preparo el servicio de Google para calculo de itinererios
        this.directionsService = new google.maps.DirectionsService();
        // Preparo el servicio de Google para renderizar los resultados
        this.directionsRenderer = new google.maps.DirectionsRenderer();
        if (fromId && toId) {
            let options: any = {};
            const sb = gMap.searchBounds.split(',');
            if (sb.length === 4) {
                // Restrinjo el área de busqueda preferido
                const sw = new google.maps.LatLng(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]));
                const ne = new google.maps.LatLng(Number.parseFloat(sb[2]), Number.parseFloat(sb[3]));
                options = {
                    location: new google.maps.LatLng(sw.lat() + (ne.lat() - sw.lat()) / 2, sw.lng() + (ne.lng() - sw.lng()) / 2),
                    bounds: new google.maps.LatLngBounds(sw, ne),
                    types: ['geocode']
                }
            } else {
                options = {
                    types: ['geocode']
                }
            }
            // Añado la restricción por pais si se ha especificado
            if (gMap.searchCountry.length >= 2) {
                options.componentRestrictions = {
                    country: gMap.searchCountry
                }
            }
            // Preparo los autocompletados
            this.autocompleteFrom = new google.maps.places.Autocomplete(this.fromElem, options);
            this.autocompleteFrom.addListener('place_changed', () => {
                ngZone.run(() => {
                    const place = this.autocompleteFrom.getPlace();
                    if (place.geometry !== undefined && place.geometry !== null) {
                        this.origen = place.geometry.location;
                        if (this.origen && this.destino) {
                            this.calcItinerary();
                        }
                    }
                });
            });
            this.autocompleteTo = new google.maps.places.Autocomplete(this.toElem, options);
            this.autocompleteTo.addListener('place_changed', () => {
                ngZone.run(() => {
                    const place = this.autocompleteTo.getPlace();
                    if (place.geometry && place.geometry) {
                        this.destino = place.geometry.location;
                        if (this.origen && this.destino) {
                            this.calcItinerary();
                        }
                    }
                });
            });
        } else {
            this.setOrigen(fromPos);
            this.setDestino(toPos);
        }
    }

    override setOrigen(pos: MapLatLng) {
        this.origen = new google.maps.LatLng(pos.lat, pos.lng);
    }

    override setDestino(pos: MapLatLng) {
        this.destino = new google.maps.LatLng(pos.lat, pos.lng);
    }

    override getOrigen(): MapLatLng {
        if (this.origen) {
            return new MapLatLng(this.origen.lat(), this.origen.lng());
        }
        return null as any;
    }

    override getDestino(): MapLatLng {
        if (this.destino) {
            return new MapLatLng(this.destino.lat(), this.destino.lng());
        }
        return null as any;
    }

    override calcItinerary() {
        if (this.origen && this.destino) {
            this.directionsRenderer.setMap(null);
            this.directionsRenderer.setMap(this.map);
            if (this.resultElem) {
                this.resultElem.innerText = '';
                this.directionsRenderer.setPanel(this.resultElem);
            }
            this.directionsService.route({
                origin: this.origen,
                destination: this.destino,
                travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    this.directionsRenderer.setDirections(response);
                } else {
                    if (this.resultElem) {
                        this.resultElem.innerText = status;
                    }
                }
            });
        }
    }

    override remove() {
        if (this.autocompleteFrom) {
            google.maps.event.removeListener(this.autocompleteFromListener);
            google.maps.event.clearInstanceListeners(this.autocompleteFrom);
        }
        if (this.autocompleteTo) {
            google.maps.event.removeListener(this.autocompleteToListener);
            google.maps.event.clearInstanceListeners(this.autocompleteTo);
        }
        if (this.directionsRenderer) {
            if (this.resultElem) {
                this.directionsRenderer.setPanel(null as any);
            }
            this.directionsRenderer.setMap(null);
        }
    }
}
